import React, { useState, useEffect } from "react";
import { Row, Col, Container } from "shards-react";
import styled from "styled-components";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import baseUrl from "config/baseUrl";
import imgbox from "../../assets/img/imgbox.png";
import { useTranslation } from "react-i18next";

const axios = require("axios").default;

const ListGroupItem = styled.div`
  text-align: center;
  padding: 10px;
`;

const ListGroupImg = styled.img`
  max-width: 120px;
  height: 120px;
`;
const StyledContainer = styled(Container)`
  padding: 30px 0;
`;
const StyledCarousel = styled(Carousel)`
  .react-multi-carousel-list {
    position: unset;
  }
  .react-multiple-carousel__arrow {
    background: none;
    ::before {
      color: #000;
    }
  }
`;
const Agency = () => {
  const [dataTabList, setDataTabList] = useState(null);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    var data = JSON.stringify({
      params: {
        contentSettingId: 3,
      },
      show: 100,
      page: 1,
      orderBy: "contentSubSettingId",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/contentsublistshow`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        setDataTabList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
      paritialVisibilityGutter: 50,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const nextToPage = (content) => {
    if (content === "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ (สศช.)") {
      window.open("https://www.nesdc.go.th/main.php?filename=index");
    } else if (content === "กระทรวงคมนาคม") {
      window.open("https://www.mot.go.th/");
    } else if (content === "กระทรวงพาณิชย์") {
      window.open("https://www.moc.go.th/th/page/item/index/id/1");
    } else if (content === "กระทรวงเกษตรและสหกรณ์") {
      window.open("https://www.moac.go.th/site-home");
    } else if (content === "กระทรวงอุตสาหกรรม") {
      window.open("https://www.industry.go.th/page/home.aspx");
    } else if (content === "กรมศุลกากร กระทรวงการคลัง") {
      window.open("https://www.customs.go.th/");
    } else if (content === "กระทรวงศึกษาธิการ") {
      window.open("https://www.moe.go.th/");
    } else if (content === "กระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม") {
      window.open("https://www.mhesi.go.th/");
    } else if (content === "กระทรวงแรงงาน") {
      window.open("https://www.mol.go.th/");
    } else if (content === "กระทรวงพลังงาน") {
      window.open("https://energy.go.th/th/home");
    } else if (content === "กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม") {
      window.open("https://www.mdes.go.th/");
    } else {
      window.open("/");
    }
  };
  return (
    <StyledContainer>
      <Row>
        <Col className="text-center">
          <h5 className="bold text-balck">
            - {t("common:homePage.LinkWebsite")} -
          </h5>
        </Col>
      </Row>
      <StyledCarousel
        additionalTransfrom={0}
        arrows
        autoPlay={true}
        autoPlaySpeed={2000}
        centerMode={false}
        className="carousel-agency-container"
        containerClass="container-with-dots"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        renderButtonGroupOutside={false}
        renderDotsOutside={false}
        responsive={responsive}
        showDots={false}
        sliderClass=""
        slidesToSlide={1}
      >
        {dataTabList != null &&
          dataTabList.data.length > 0 &&
          dataTabList.data.map((item, key) => (
            <ListGroupItem
              key={key}
              onClick={() => nextToPage(item.contentSubSettingName)}
              style={{ cursor: "pointer" }}
            >
              <ListGroupImg
                src={
                  item.contentSubSettingPic
                    ? `${baseUrl}/${item.contentSubSettingPic}`
                    : imgbox
                }
              />
            </ListGroupItem>
          ))}
      </StyledCarousel>
    </StyledContainer>
  );
};
export default Agency;
